import React, { useState } from 'react';

interface ImageLoaderProps extends React.ImgHTMLAttributes<HTMLImageElement> {
  effect?: 'opacity' | 'none';
  effectDuration?: number;
  wrapperStyle?: React.CSSProperties;
  width?: number | string;
  height?: number | string;
}

const ImageLoader: React.FC<ImageLoaderProps> = ({
  src,
  alt = '',
  effect = 'opacity',
  effectDuration = 600,
  wrapperStyle,
  width,
  height,
  style,
  ...imgProps
}) => {
  const [loaded, setLoaded] = useState(false);

  const transitionStyle =
    effect === 'opacity'
      ? {
          opacity: loaded ? 1 : 0,
          transition: `opacity ${effectDuration}ms ease-in-out`,
        }
      : {};

  return (
    <div
      style={{
        display: 'inline-block',
        width,
        height,
        ...wrapperStyle,
      }}
    >
      <img
        src={src}
        alt={alt}
        onLoad={() => setLoaded(true)}
        style={{
          width: '100%',
          height: '100%',
          objectFit: 'contain',
          ...transitionStyle,
          ...style,
        }}
        {...imgProps}
      />
    </div>
  );
};

export default ImageLoader;
